export default function SectionComments() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block text-xs font-medium text-accent-600 tracking-wider uppercase mb-3 whitespace-nowrap">
            Community
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900">
            吃瓜群众说
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          <div className="bg-background-100 rounded-2xl p-5 md:p-6 border border-background-200/70">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center text-accent-600 font-heading font-bold text-sm">
                吃
              </div>
              <div>
                <div className="text-sm font-medium text-foreground-800">吃瓜一线记者</div>
                <div className="text-xs text-foreground-400">2小时前</div>
              </div>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              这个平台也太好玩了！每天上班第一件事就是打开每日大赛看看今天又有什么新鲜瓜，比刷微博有意思多了。投票机制很公平，赞一个！
            </p>
          </div>

          <div className="bg-background-100 rounded-2xl p-5 md:p-6 border border-background-200/70">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-heading font-bold text-sm">
                瓜
              </div>
              <div>
                <div className="text-sm font-medium text-foreground-800">熬夜吃瓜人</div>
                <div className="text-xs text-foreground-400">5小时前</div>
              </div>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              深度分析栏目做得真心好，每次看完都能把整个事件的来龙去脉搞清楚。比起那些只爆标题的营销号，这里的内容靠谱多了。
            </p>
          </div>

          <div className="bg-background-100 rounded-2xl p-5 md:p-6 border border-background-200/70">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center text-accent-600 font-heading font-bold text-sm">
                众
              </div>
              <div>
                <div className="text-sm font-medium text-foreground-800">八卦探测器</div>
                <div className="text-xs text-foreground-400">8小时前</div>
              </div>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              独家爆料的质量真的高！好几条都是在这里先看到，然后才在微博热搜上出现。感觉这里才是真正的吃瓜前线，墙裂推荐给朋友了。
            </p>
          </div>

          <div className="bg-background-100 rounded-2xl p-5 md:p-6 border border-background-200/70">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-heading font-bold text-sm">
                料
              </div>
              <div>
                <div className="text-sm font-medium text-foreground-800">专业吃瓜户</div>
                <div className="text-xs text-foreground-400">1天前</div>
              </div>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              每天更新真的很勤快，而且分类也很清晰。想看视频有吃瓜现场，想投票有热度榜，想深度了解有专题，基本上所有吃瓜需求都满足了。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}